import { render, staticRenderFns } from "./input-field-header.vue?vue&type=template&id=18084a7c&scoped=true"
import script from "./input-field-header.vue?vue&type=script&lang=js"
export * from "./input-field-header.vue?vue&type=script&lang=js"
import style0 from "./input-field-header.vue?vue&type=style&index=0&id=18084a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18084a7c",
  null
  
)

export default component.exports